import styles from './SituacaoBadge.module.css'
import { __SITUACOES } from '../../config'

function SituacaoBadge({situacao}) {
    const item = __SITUACOES.find((s) => s.value === situacao)
    if (!item) return null

    return <span className={`${styles.situacaoBadge} ${styles[`situacao-${item.value}`]}`}>{item.label.toUpperCase()}</span>
}

export default SituacaoBadge
